import * as API from './API'
import * as CacheUtil from '../util/CacheUtil'

export const srcOf=(content,w=312)=>{
  if (typeof(content)==='object'&&content!==null) {
    const {images} = content
    if (Array.isArray(images)&&images.length>0) {
      const image = images[0]
      if (typeof(image)==='object'&&image!==null) {
        const {name,sizes} = image
        if (typeof(name)==='string'&&name.length>0) {
          if (Array.isArray(sizes)&&sizes.length>0) {
            for (const i in sizes) {
              const size = sizes[i]
              if (typeof(size)==='object'&&size!==null) {
                const {width} = size
                if (typeof(width)==='number') {
                  if (width>=w) {
                    return `/data/images/w${width}/${name}`
                  }
                }
              }
            }
          }
          return `/data/images/_/${name}`
        }
      }
    }
  }
  return ''
}

export const fetchAggregates=(cb,cbe)=>{
  API.aggregates(cb,cbe)
}

export const fetchContents=(type,cb,cbe)=>{
  API.contents(type,cb,cbe)
}

export const fetchSlugs=(type,cb,cbe)=>{
  API.slugs(type,cb,cbe)
}

export const fetchQueue=(name,page,cb,cbe)=>{
  API.queue(name,page,cb,cbe)
}

export const _UPDATED = '_updated'
export const Q_NAME = ''
export const POST = 'Post'
export const POST__SLUG = 'Post__slug'

export const fetchUpdated=(cb,cbe)=>{
  API.text(_UPDATED,text=>{
    if (typeof(text)==='string'&&text.length>0) {
      const updated = parseInt(text,10)
      if (typeof(updated)==='number') {
        const lastUpdated = CacheUtil.get(_UPDATED)
        if (lastUpdated===undefined||lastUpdated!==updated) {
          CacheUtil.remove(Q_NAME)
          CacheUtil.remove(POST__SLUG)
          CacheUtil.remove(_UPDATED)
          CacheUtil.set(_UPDATED,updated)
        }
        if (typeof(cb)==='function') {
          cb()
        }
      }
    }
  },cbe)
}
